/*** variant option selection dependent option reselect script ***/

$(document).on("click", ".radio_check", function(){   
  var $data_value,
    $swatch,
    $option_index,
    $val_avail = [];
  
    $data_value = $(this).attr("value");    
    $swatch = $(this).attr("data-swatch");    
    $option_index = $(this).attr("data-option"); 
    if($swatch == "Size"){
      //console.log("Size - "+$data_value);
      $(".ColorSwatchList li").removeClass("sold-out"); 
      if($option_index == "option1"){  
          $(".first-"+$data_value).each(function(){
             var quanity = $(this).attr("data-variant");
             var available = $(this).attr("data-available"); 
             var op = $(this).attr("data-option2");  
            // console.log(op+","+available);
             $val_avail.push(op);
             if(quanity >= 1 && available == "deny"){
               $(".color_"+op).removeClass("sold-out");     
             }else if(quanity <= 0){
               $(".color_"+op).addClass("sold-out");  
             }
          });      
             
      }else if($option_index == "option2"){    
        $(".second-"+$data_value).each(function(){
           var quanity = $(this).attr("data-variant");
           var available = $(this).attr("data-available"); 
           var op = $(this).attr("data-option1");  
           $val_avail.push(op);
           if(quanity >= 1 && available == "deny"){
             $(".color_"+op).removeClass("sold-out");     
           }else if(quanity <= 0){
             $(".color_"+op).addClass("sold-out");  
           }
        }); 
      }
      $(".ColorSwatchList li").each(function(){
          var cl = $(this).attr("data-color");
          if($.inArray( cl, $val_avail )!= -1){
          }else{
            $(this).addClass("sold-out");
          }
      });
    }else if($swatch == "Color"){
      $(".SizeSwatchList li").removeClass("sold-out");  
      if($option_index == "option1"){  
        $(".first-"+$data_value).each(function(){
           var quanity = $(this).attr("data-variant");
           var available = $(this).attr("data-available"); 
           var op = $(this).attr("data-option2"); 
           $val_avail.push(op);
           if(quanity >= 1 && available == "deny"){
             $(".size_"+op).removeClass("sold-out");     
           }else if(quanity <= 0){
             $(".size_"+op).addClass("sold-out");  
           }
        });  
             
      }else if($option_index == "option2"){   
        $(".second-"+$data_value).each(function(){
           var quanity = $(this).attr("data-variant");
           var available = $(this).attr("data-available"); 
           var op = $(this).attr("data-option1");  
           $val_avail.push(op);
           if(quanity >= 1 && available == "deny"){
             $(".size_"+op).removeClass("sold-out");     
           }else if(quanity <= 0){
             $(".size_"+op).addClass("sold-out");  
           }
        }); 
      }
      $(".SizeSwatchList li").each(function(){
                var cl = $(this).attr("data-size");
          		if($.inArray( cl, $val_avail )!= -1){
                }else{
                  $(this).addClass("sold-out");
                }
      }); 
    }
  
  
});
